<template lang="pug">
yz-dialog(v-model="showDialog" persistent scrollable max-width="496")
  yz-card
    yz-dialog-normal-header(title="Unassign branch from HQ service" @close="onCloseDialog")
    yz-dialog-normal-content
      .pt-6.pb-2
        .d-flex.align-center.gap-2
          v-icon(color="danger500" size="20") $yzi-alert-circle-solid
          .yz-medium-body-md.text-neutral-700 This location has existing appointments for this service.
        .yz-regular-body-sm.text-neutral-700.mt-2 Location cannot be unassigned while appointments are scheduled. Please cancel or complete all appointments first.
    yz-dialog-normal-actions(justify="space-between")
      yz-btn(size="lg" text text-color="yz-neutral-700" label="Cancel" @click="onCloseDialog")
      .d-flex.align-center(style="gap: 12px;")
        yz-btn(size="lg" label="View appointments" secondary @click="onViewAppointments")
        yz-btn(size="lg" color="danger" label="Bulk cancel appointments" @click="onBulkCancel")
</template>

<script>
export default {
  name: 'UnassignBranchWarningDialog',
  props: {
    value: { type: Boolean, default: false },
    branchId: { type: [Number, String], default: null },
    branchName: { type: String, default: '' },
    appointmentIds: { type: Array, default: () => [] },
  },
  computed: {
    showDialog: {
      get () { return this.value },
      set (val) { this.$emit('input', val) },
    },
  },
  methods: {
    onBulkCancel () {
      this.$emit('request-bulk-cancel', {
        branchId: this.branchId,
        branchName: this.branchName,
        appointmentIds: [...this.appointmentIds],
      })
      this.showDialog = false
    },
    onViewAppointments () {
      this.$emit('view-appointments', { branchId: this.branchId, branchName: this.branchName })
    },
    onCloseDialog () {
      this.showDialog = false
    },
  },
}
</script>
